module.exports = __webpack_public_path__ + "bondhushava-f83221de00347b239d89.svg";